<template>
<div class="courseAndQuesDialog" v-if="dialogVisible">
    <el-dialog @close='cancel' title="选择商品" :visible.sync="dialogVisible" width="650px">
        <el-tabs type="card" v-model="activeName" addable @tab-click="handleChange" :class="[activeName=='course'?'course':'ques']">
            <el-tab-pane label="课程" name="course">
                <div class="right_main_box">
                    <div class="search_box">
                        <div class="innerbox">
                            <el-button @click="handleCheck" type="text" size="small">取消选择</el-button>
                        </div>
                        <div class="innerbox">
                            <el-input placeholder="输入课程名称" v-model="course.param.key" clearable></el-input>
                            <el-button type="primary" @click="handelQuery" plain>搜索</el-button>
                        </div>
                    </div>
                    <div class="add_goods_tabs_box">
                        <el-table :data="course.tableData" style="width: 100%" :show-header="true"
                                  ref="multipleTable1"
                                  @select="handleSelectionChange" @row-click="handleRowChange"
                                  @select-all="handleAllSelectionChange">
                            <el-table-column type="selection" width="45" :show-overflow-tooltip="false"></el-table-column>
                            <el-table-column label="课程信息">
                                <template slot-scope="scope">
                                    <div class="goods_item_box">
                                        <div class="left">
                                            <img class="img" v-lazy="scope.row.coverurl" alt>
                                        </div>
                                        <div class="right">
                                            <div class="text-ellipse innerbox">{{scope.row.kmcname}}</div>
                                            <div class="tc-red innerbox">{{scope.row.saleprice=='0.00'?'免费': '￥' + scope.row.saleprice}}</div>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="page" style="margin-top: 15px; text-align: center">
                        <el-pagination
                            background
                            @current-change="handleSizeChange"
                            :current-page.sync="course.page.page"
                            :page-size="course.page.pageSize"
                            :pager-count="11"
                            layout="prev, pager, next"
                            :total="course.total">
                        </el-pagination>
                    </div>
                    <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
                        <el-button @click="cancel">取 消</el-button>
                        <el-button type="primary" @click="handleSure()">确 定</el-button>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="题库" name="ques">
                <div class="right_main_box">
                    <div class="search_box">
                        <div class="innerbox">
                            <el-button @click="handleCheck" type="text" size="small">取消选择</el-button>
                        </div>
                        <div class="innerbox">
                            <el-input placeholder="输入题库" v-model="ques.param.key" clearable></el-input>
                            <el-button type="primary" @click="handelQuery" plain>搜索</el-button>
                        </div>
                    </div>
                    <div class="add_goods_tabs_box">
                        <el-table :data="ques.tableData" style="width: 100%" ref="multipleTable2"
                                  @select="handleSelectionChange" @row-click="handleRowChange">
                            <el-table-column type="selection" width="45" :show-overflow-tooltip="false"></el-table-column>
                            <el-table-column label="题库信息">
                                <template slot-scope="scope">
                                    <div class="goods_item_box">
                                        <div class="left">
                                            <img class="img" v-lazy="scope.row.coverurl" alt>
                                        </div>
                                        <div class="right">
                                            <div class="text-ellipse innerbox">{{scope.row.kmcname}}</div>
                                            <div class="tc-red innerbox">{{scope.row.saleprice=='0.00'?'免费': '￥' + scope.row.saleprice}}</div>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="page" style="margin-top: 15px; text-align: center">
                        <el-pagination
                            background
                            @current-change="handleSizeChange"
                            :current-page.sync="ques.page.page"
                            :page-size="ques.page.pageSize"
                            :pager-count="11"
                            layout="prev, pager, next"
                            :total="ques.total">
                        </el-pagination>
                    </div>
                    <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
                        <el-button @click="cancel">取 消</el-button>
                        <el-button type="primary" @click="handleSure()">确 定</el-button>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </el-dialog>
</div>
</template>

<script>
import {getCommonformKMCList} from 'api/operateToolApi'
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'courseAndQuesDialog',
    data() {
        return {
            dialogVisible: false,
            activeName: 'course',
            course: {
                param: {
                    kmcname: '',
                    kmctype: 7
                },
                page: {
                    page: 1,
                    pageSize: 20,
                    pageCount: 0
                },
                total: 0,
                tableData: [],
            },
            ques: {
                param: {
                    kmcname: '',
                    kmctype: 8
                },
                page: {
                    page: 1,
                    pageSize: 20,
                    pageCount: 0
                },
                total: 0,
                tableData: [],
            },
            selectedResult: [],
        }
    },
    mounted() {
    },
    methods: {
        handleChange() {
            if (this.activeName == 'course') {
                this._getList()
            } else {
                this._getList2()
            }
        },
        handleCheck() {
            if (this.activeName == 'course') {
                this.course.tableData.forEach(obj => {
                    if (obj.isCheck) {
                        this._changeSelection(obj)
                        this.$refs.multipleTable1.toggleRowSelection(obj, false)
                    }
                })
                let list = []
                this.selectedResult.forEach(obj => {
                    if (obj.isopenevent) {
                        list.push(obj)
                    }
                })
                this.selectedResult = list
            } else {
                this.ques.tableData.forEach(obj => {
                    obj.isCheck = false
                })
                this.$refs.multipleTable2.clearSelection()
                this.selectedResult = []
            }
        },
        handleSizeChange() {
            if (this.activeName == 'course') {
                this._getList()
            } else {
                this._getList2()
            }
        },
        openDialog(selectedResult) {
            selectedResult = this._.cloneDeep(selectedResult)
            this.course.tableData = []
            this.ques.tableData = []
            this.dialogVisible = true
            this.selectedResult = selectedResult || []
            this._getList()
        },
        cancel() {
            this.course.tableData = []
            this.ques.tableData = []
            this.course.page.page = 1
            this.ques.page.page = 1
            this.course.param.key = ''
            this.ques.param.key = ''
            this.activeName = 'course',
                this.dialogVisible = false
        },
        handelQuery() {
            if (this.activeName == 'course') {
                this.course.page.page = 1
                this.course.tableData = []
                this._getList()
            } else {
                this.ques.page.page = 1
                this.ques.tableData = []
                this._getList2()
            }
        },
        _getList() {
            this.setLoading(true)
            getCommonformKMCList({
                data: Object.assign({}, this.course.param, this.course.page),
                success: data => {
                    data.data.content.forEach(obj => {
                        obj.isCheck = false
                    })
                    this.course.tableData = data.data.content
                    this.$nextTick(() => {
                        this.selectedResult.forEach((obj, i) => {
                            this.course.tableData.forEach((obj2, j) => {
                                if (obj.kmcinnerid === obj2.kmcinnerid) {
                                    obj2.isCheck = true
                                    this.$refs.multipleTable1.toggleRowSelection(this.course.tableData[j])
                                    return false
                                }
                            })
                        })
                    })
                    this.course.total = data.data.pageinfo.rowCount
                    this.course.page.pageCount = data.data.pageinfo.pageCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getList2() {
            this.setLoading(true)
            getCommonformKMCList({
                data: Object.assign({}, this.ques.param, this.ques.page),
                success: data => {
                    data.data.content.forEach(obj => {
                        obj.isCheck = false
                    })
                    this.ques.tableData = data.data.content
                    this.$nextTick(() => {
                        this.selectedResult.forEach((obj, i) => {
                            this.ques.tableData.forEach((obj2, j) => {
                                if (obj.kmcinnerid === obj2.kmcinnerid) {
                                    obj2.innerid = obj.innerid
                                    obj2.isCheck = true
                                    this.$refs.multipleTable2.toggleRowSelection(this.ques.tableData[j])
                                    return false
                                }
                            })
                        })
                    })
                    this.ques.total = data.data.pageinfo.rowCount
                    this.ques.page.pageCount = data.data.pageinfo.pageCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        handleAllSelectionChange(selection) {
            if (this.activeName == 'course') {
                this.course.tableData.forEach((obj, i) => {
                    this._changeSelection(obj)
                })
            } else {
                this.ques.tableData.forEach((obj, i) => {
                    this._changeSelection(obj)
                })
            }
        },
        handleSelectionChange(selection, row) {
            this._changeSelection(row)
        },
        handleRowChange(row) {
            if (this.activeName == 'course') {
                if (!row.isCheck) {
                    this.$refs.multipleTable1.toggleRowSelection(row)
                } else {
                    this.$refs.multipleTable1.toggleRowSelection(row, false)
                }
            } else {
                if (!row.isCheck) {
                    this.$refs.multipleTable2.toggleRowSelection(row)
                } else {
                    this.$refs.multipleTable2.toggleRowSelection(row, false)
                }
            }
            this._changeSelection(row)
        },
        _changeSelection(row) {
            row.isCheck = !row.isCheck
            if (row.isCheck) {
                let obj = {
                    innerid: '',
                    kmcinnerid: row.kmcinnerid,
                    kmcname: row.kmcname,
                    kmctype: row.kmctype,
                    kmctypename: row.kmctypename,
                    coverurl: row.coverurl
                }
                this.selectedResult.push(obj)
            } else {
                this.selectedResult.forEach((obj1, index1) => {
                    if (obj1.kmcinnerid === row.kmcinnerid) {
                        this.selectedResult.splice(index1, 1)
                    }
                })
            }
        },
        handleSure() {
            this.$emit('setCourseQuesList', this.selectedResult)
            this.cancel()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user', 'brandBusiness'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.courseAndQuesDialog {
    display: flex;
    .right_main_box {
        width: 100%;
    }
    .search_box {
        display: flex;
        margin-bottom: 10px;
        justify-content: space-between;
        .innerbox {
            display: flex;
            align-items: center;
        }
        .el-input {
            width: 240px;
        }
        .el-input__inner {
            height: 32px;
        }
        .el-input__icon {
            line-height: 32px;
        }
        .el-button,
        .el-button--mini {
            height: 32px;
            width: 96px;
            margin-left: 20px;
            margin-bottom: 0px;
        }
    }
    .add_goods_tabs_box {
        .el-table {
            min-height: 340px;
        }
        .goods_item_box {
            display: flex;
            align-items: center;
            height: 50px;
            box-sizing: border-box;
            .left {
                position: relative;
                margin-right: 12px;
                .img {
                    width: 81px;
                    height: 48px;
                }
            }
            .right{
                flex-grow: 1;
                overflow: hidden;
                .innerbox{
                    width: 100%;
                }
            }
        }
        .el-table__empty-block {
            height: 340px;
            max-height: 340px;
        }
        .el-table__empty-text {
            position: relative;
            top: 80px;
        }
    }
    .el-table::before {
        height: 0;
    }
    .el-tabs__new-tab {
        width: 100px;
        border-width: 0;
        color: #606266;
        font-size: 14px;
        &:hover {
            color: #409EFF;
        }
        .el-icon-plus:before {
            content: '';
        }
    }
    /*.course .el-tabs__new-tab:after {*/
        /*content: '邀请团长';*/
    /*}*/
    /*.ques .el-tabs__new-tab:after {*/
        /*content: '+ 提货点';*/
    /*}*/
    .el-table__body-wrapper {
        height: 350px;
        overflow-y: auto !important;
    }
}
</style>
